import React from "react"
import clsx from "classnames"
import PropTypes from "prop-types"

const SubmitButton = ({ active = true, text = "" }) => (
  <button
    className={clsx(
      "w-full cursor-pointer rounded-xs border-0 bg-blue-600 px-6 py-3 font-sans text-sm text-white transition ease-in-out enabled:hover:bg-gray-300 enabled:hover:drop-shadow-md sm:w-fit",
      {
        "cursor-not-allowed opacity-40": !active,
      },
    )}
    type="submit"
    name="commit"
    disabled={!active}
    id="submit-button"
  >
    {text}
  </button>
)

export default SubmitButton

SubmitButton.propTypes = {
  active: PropTypes.bool,
  text: PropTypes.string,
}
